<template>
  <div class="people" v-bind:class="{ 'reverse_position': isReverse }">
    <div class="hero">
      <img :src="image" />
    </div>
    <div class="people-overview-wrap">
      <div class="people-overview-inner">
        <div class="catch-wrap">
          <p class="catch" v-html="mainCatch">
          </p>
        </div>
        <div class="profile-wrap">
          <div class="profile-inner">
            <p class="name">
              <img :src="name" alt="">
            </p>
            <p class="background" v-html="background">
            </p>
            <p class="history"  v-html="history">
            </p>
          </div>
        </div>
      </div>
    </div>
    <slot/>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'people',
  props: {
    isReverse: Boolean,
    image: String,
    mainCatch: String,
    name: String,
    background: String,
    history: String,
  }
}
</script>

<style lang="scss" scoped>
.people {
  width: 100%;
  overflow: hidden;
}
.reverse_position {
  .people-overview-wrap {
    justify-content: flex-start;
    @media print, screen and (min-width: 1161px) {
      margin-left: 50px;
    }
  }
  .people-overview-inner {
    text-align: left;
  }
}
.hero {
  position: relative;
  &:after {
    content: "";
    width: 100%;
    height: 300px;
    display: block;
    background: linear-gradient(to right, #ffcf82 0%,#543194 100%);
    background-size: 200% 200%;
    animation: gradientAnime 10s ease infinite;
    position: absolute;
    transform: skewY(-20deg);
    transform-origin: right top;
    z-index: -1;
    bottom: 0;
    right: -20%;
  }
}
.people-overview-wrap {
  display: flex;
  justify-content: flex-end;
  @media print, screen and (min-width: 1161px) {
    margin-top: -600px;
    margin-right: 50px;
  }
  @media print, screen and (max-width: 1160px) {
    margin-top: -20px;
  }
}
.people-overview-inner {
  position: relative;
  color: #fff;
  display: block;
  width: 100%;
  text-align: right;
  @media print, screen and (min-width: 1161px) {
    max-width: 570px;
  }
  .catch-wrap {
    text-align: left;
    background-color: #543193;
    font-family: 'Noto Serif JP', serif;
    margin: 0 auto;
    @media print, screen and (min-width: 1161px) {
      padding: 50px;
      font-size: 28px;
      display: inline-block;
      margin-bottom: 50px;
    }
    @media print, screen and (max-width: 1160px) {
      font-size: 18px;
      width: 90%;
      margin-bottom: 10px;
    }
  }
  .catch {
    margin: 0 auto;
    @media print, screen and (max-width: 1160px) {
      width: 90%;
      padding: 20px 0;
    }
  }
  .profile-wrap {
    text-align: left;
    background-color: #543193;
    margin: 0 auto;
    margin-bottom: 100px;
    @media print, screen and (min-width: 1161px) {
      padding: 50px;
      display: inline-block;
    }
    @media print, screen and (max-width: 1160px) {
      width: 90%;
      margin-bottom: 50px;
    }
  }
  .profile-inner {
    width: 100%;
    margin: 0 auto;
    @media print, screen and (min-width: 1161px) {
      max-width: 420px;
    }
    @media print, screen and (max-width: 1160px) {
      width: 90%;
      padding: 20px 0;
    }
    .name {
      font-size: 40px;
      margin-top: 0;
      margin-bottom: 1em;
      height: 1em;
      @media print, screen and (max-width: 1160px) {
        font-size: 18px;
      }
      img {
        height: inherit;
      }
    }
    .background {
      font-size: 12px;
    }
    .history {
      font-size: 12px;
      margin-bottom: 0;
    }
  }
}
</style>